import { Component } from "react";
import {
  getStoreComment,
  createStoreComment,
  updateStoreComment,
  getStore
} from "../../../backend/stores";
import { getStoreMachines } from "../../../backend/machines";
import { getStoreTools } from "../../../backend/machines";
import { getFaultyList } from "../../../backend/machines";
import { getConditionList } from "../../../backend/machines";
import { getCheckUserType } from "../../../backend/machines";
import View from "./view";
import "./index.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { updateRoute, select } from "../../../redux/actions";

class CommentForm extends Component {
  constructor(props) {
    super(props);
   
    this.state = {
      machines: [],
      tools : [],
      confirmDialogVisible: false,
      spare_hire_book: undefined,
      uploading: false,
      loading: false,
      reinspectionForm: Boolean(props.match.params.comment_id),
      sheet_required: undefined,
      new_book_required: undefined,
      hire_docket_collected: undefined,
      docket_num_01: undefined,
      docket_num_02: undefined,
      docket_comment: undefined,
      request_docket: undefined,
      request_docket_comment: undefined,
      request_docket_comment2: undefined,
      stand_condition: undefined,
      stand_note: undefined,
      alert: undefined,
    };

    this._toggleConfirmDialog = this._toggleConfirmDialog.bind(this);
    this._upload = this._upload.bind(this);
    this._navigate = this._navigate.bind(this);
    this._editMachine = this._editMachine.bind(this);
    this._editTool = this._editTool.bind(this);
    this._valid = this._valid.bind(this);

  }

  async componentDidMount() {
    if ( this.props.match.params.store_id && !this.props.match.params.comment_id ) {
        // 스토어 아이디 있고, 코멘트없어 :: NEW add store inspection 
        const { name, id, use_app } = await getStore(this.props.match.params.store_id);
        const faulty_list = await getFaultyList(this.props.match.params.store_id)
        const stand_condition_list_arr = await getConditionList()
        const stand_condition_list = [];
        const m_faulty_list = [];
        const t_faulty_list = [];
        let checkType = await getCheckUserType(this.props.match.params.store_id)
        
        if (checkType === false){
          window.location.href = "/stores"
        }
        faulty_list.map(
          ({id,type, name}, key) => type === 'Machine' && (
            m_faulty_list.push({ key:key, value: id, label: name })
          )
        )
        faulty_list.map(
          ({id,type, name}, key) => type === 'Tool' && (
            t_faulty_list.push({ key:key, value: id, label: name })
          )
        )
        stand_condition_list_arr.map(
          ({ label }, key) => (
            stand_condition_list.push({ key:key, value: label, label: label })
          )
        )

        this.setState({ loading: true });
        this.setState({
          loading: false,
          store: { label: name, value: id, use_app : use_app },
          machines: await getStoreMachines(this.props.match.params.store_id, 'av'),
          tools: await getStoreTools(this.props.match.params.store_id, 'av'),
          faulty_list : faulty_list, 
          m_faulty_list: m_faulty_list,
          t_faulty_list: t_faulty_list,
          stand_condition_list: stand_condition_list,
          checkType : checkType
        });
    } else if (this.props.match.params.comment_id) {
      // 코멘트 아이디 있음
      this.setState({ loading: true });
      this.setState({
        loading: false,
        store: await getStore(this.props.match.params.store_id),
        ...(await getStoreComment(this.props.match.params.comment_id))
      });
    } else if (!this.props.match.params.store_id && !this.props.match.params.comment_id){
      // 암것도 없어 돌려보내.
      let checkType = await getCheckUserType()
      if (checkType === 4 || checkType === 3){
        window.location.href = "/stores"
      }
    }
    
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.match.params.store_id !== this.props.match.params.store_id &&
      this.props.match.params.store_id
    ) {
      // updating same store

      this.setState({ loading: true });
      this.setState({
        machines: await getStoreMachines(this.props.match.params.store_id),
        tools: await getStoreTools(this.props.match.params.store_id),
        faulty_list : await getFaultyList(this.props.match.params.store_id),
        stand_condition_list: await getConditionList(),
        loading: false
      });
    } else if (
      prevProps.match.params.comment_id &&
      !this.props.match.params.comment_id
    ) {
      this.setState({ loading: true });
      let store_id = this.props.match.params.store_id ? this.props.match.params.store_id : prevProps.match.params.store_id
      
      window.location.href = "/comment-form/"+store_id
    }
  }

  render() {
    return View.call(this);
  }

  _editMachine(index, inputType = "input", prop) {
    return event => {
      let value;
      if (inputType === "radio") {
        value = event;
      } else if (inputType === "select") {
        value = event.value;
      } else if (inputType === "input") {
        value = event.target.value;
      }

      let { machines } = this.state;
      machines = machines.map((m, i) => {
        if (i === index) {
          if (prop === 'faulty_reason'){
            let text = event.label;
            let other = event.label === 'Other' ? 1 : 0;
            return { ...m, faulty_reason: { id : value, text: text, other: other } }
          } else if (prop === 'faulty_reason_text'){
            // return faulty_reason.text = event.target.value
            return { ...m, faulty_reason: { ...m.faulty_reason, text: event.target.value } }
          }else{
            return { ...m, [prop]: value };
          }
        } else {
          return m;
        }
      });
      
      this.setState({ machines });
    };
  }

  _editTool(index, inputType = "input", prop) {
    return event => {
      let value;
      if (inputType === "radio") {
        value = event;
      } else if (inputType === "select") {
        value = event.value;
      } else if (inputType === "input") {
        value = event.target.value;
      }

      let { tools } = this.state;
      tools = tools.map((m, i) => {
        if (i === index) {
          if (prop === 'faulty_reason'){
            let text = event.label;
            let other = event.label === 'Other' ? 1 : 0;
            return { ...m, faulty_reason: { id : value, text: text, other: other } }
          } else if (prop === 'faulty_reason_text'){
            // return faulty_reason.text = event.target.value
            return { ...m, faulty_reason: { ...m.faulty_reason, text: event.target.value } }
          }else{
            return { ...m, [prop]: value };
          }
        } else {
          return m;
        }
      });

      this.setState({ tools });
    };
  }

  async _upload() {
    const {
      machines,
      tools,
      inspection_note,
      priority,
      require_action,
      reinspectionForm,
      complete,
      added_note,
      sheet_required,
      spare_hire_book,
      new_book_required,
      hire_docket_collected,
      docket_num_01,
      docket_num_02,
      docket_comment,
      request_docket,
      request_docket_comment,
      request_docket_comment2,
      stand_condition,
      stand_note,
      alert,
    } = this.state;
    this.setState({ uploading: true });

    // check 

    if (reinspectionForm) {
      await updateStoreComment({
        store_id: this.props.match.params.store_id,
        group_id: this.props.match.params.comment_id,
        complete,
        added_note,
        require_action,
        sheet_required,
        spare_hire_book,
        new_book_required,
        hire_docket_collected,
        docket_num_01,
        docket_num_02,
        docket_comment,
        request_docket,
        request_docket_comment,
        request_docket_comment2,
        stand_condition,
        stand_note,
        alert,
      });
    } else {
      await createStoreComment({
        store_id: this.props.match.params.store_id,
        priority,
        inspection_note,
        machines,
        tools,
        require_action,
        sheet_required,
        spare_hire_book,
        new_book_required,
        hire_docket_collected,
        docket_num_01,
        docket_num_02,
        docket_comment,
        request_docket,
        request_docket_comment,
        request_docket_comment2,
        stand_condition,
        stand_note,
        alert,
      });
    }
    this.setState({ uploading: false });
    this.props.redirect && this._navigate(`/stores/${this.props.match.params.store_id}`)();
  }

  _toggleConfirmDialog() {
    this.setState({ confirmDialogVisible: !this.state.confirmDialogVisible });
  }

  _valid() {
    return this.state.reinspectionForm
            ? this.state.added_note !== undefined
            : (this.state.store !== undefined && this.state.store.use_app === 0 ) 
              ? (
                this.state.sheet_required !== undefined &&
                this.state.spare_hire_book !== undefined &&
                this.state.hire_docket_collected !== undefined &&
                (this.state.hire_docket_collected === 1 
                  ? this.state.docket_num_01 !== undefined && this.state.docket_num_01 !== '' && this.state.docket_num_02 !== undefined && this.state.docket_num_02 !== ''
                  : this.state.docket_comment !== undefined  && this.state.docket_comment !== ''
                ) &&
                this.state.request_docket !== undefined &&
                ( this.state.request_docket === 1
                  ? this.state.request_docket_comment !== undefined && this.state.request_docket_comment !== "" && this.state.request_docket_comment2 !== undefined && this.state.request_docket_comment2 !==  ''
                  : true
                ) &&
                this.state.stand_condition !== undefined &&
                this.state.alert !== undefined
              ) 
              : (
                this.state.stand_condition !== undefined &&
                this.state.alert !== undefined
              )
            
            
    // return true;
  }
  _setStore(value, label, use_app){
    return ()=>{
      this.setState({ store: { value, label, use_app } }, ()=>{
        this._navigate(`/comment-form/${value}`)
      });
    }
  }
  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  _change(prop, ev = false, sel = false) {
    return event =>
      this.setState({
        [prop]: ev ? (sel ? event.value : event) : event.target.value
      });
  }
  _emptyDocket(){
    return () => {
      this.setState({docket_num_01 : '', docket_num_02 : ''})
    }
  }
}

CommentForm.defaultProps = {
  redirect: true
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateRoute: store_id => {
      dispatch(updateRoute("machines", `/machines/${store_id}`));
      dispatch(updateRoute("stores", `/stores/${store_id}`));
      dispatch(updateRoute("create", `/comment-form/${store_id}`));
    },
    selectMachine: machine => {
      dispatch(select("machine", machine));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CommentForm)
);



// WEBPACK FOOTER //
// ./src/screens/stores/comment-form/index.js